import DOMPurify from 'dompurify'

// Single choke point for every `dangerouslySetInnerHTML` in the app. The CMS
// backend (blogs, news, promos, VIP, inbox, help, sponsors) returns rich HTML
// — tables, links, formatting — so we keep DOMPurify's permissive default tag
// set rather than an allow-list, and only strip the dangerous surface:
// <script>, inline event handlers (onerror/onclick/…) and javascript:/data:
// script URIs. Any new innerHTML sink MUST route through here.
export const sanitizeHtml = (dirty: string | null | undefined): string => {
  if (!dirty) return ''

  return DOMPurify.sanitize(dirty, {
    // Links in CMS content routinely open in a new tab; keep target/rel so the
    // sanitized markup matches what editors authored.
    ADD_ATTR: ['target', 'rel'],
  })
}
